<div class="dcp">
  <div class="header">
    <div class="d-flex align-items-center justify-content-between">
      <h2 class="dialog-title">Please verify fax details</h2>
      <button mat-icon-button [disabled]="isLoading || isSending" (click)="this.dialogRef.close()" type="button">
        <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
      </button>
    </div>
    <hr class="divider" />
    <p class="dialog-message">Marking as Confirmed will set the patient status to Transfer Received</p>
  </div>
  <div class="row mt-3">
    <div class="col-md-12 d-flex gap-2 justify-content-center">
      <button class="custom-btn" [disabled]="isLoading || isSending" (click)="sendToUnmatchedQueue()">{{ isSending ?
        "Sending..." : "Send to umatched Queue" }}</button>
      <button class="btn btn-outline-primary" [disabled]="isLoading || isSending" (click)="confirmMatch()">{{ isLoading
        ? "Confirming..." : "Confirm Match" }}</button>
    </div>
  </div>